
<!-- Message popup for approve vendor payment -->
<div id="delayLeadsModal" class="modal fade" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 70%;">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title flOpions ml-3"></h4>
        <button type="button" class="close pr-4 wine-red" (click)="onCloseModal()">&times;</button>
      </div>
      <div class="modal-body modal_style">
        <div class="row mt-3 customoverflow">
          <div class="col-12 ">
            <div style="font-size: 16px; margin-bottm:15px;">Approved Payment</div>
            <table >
              <thead class="">
                <th scope="col" style="padding-left: 25px;min-width: 150px;padding-right: 8px;">
                  Lead ID</th>
                <th scope="col" style="min-width: 170px;padding-right: 8px;">Lead Name</th>
                <th scope="col" style="min-width: 175px;padding-right: 8px;">BOQ Number</th>
                <th scope="col" style="min-width: 170px;padding-right: 8px;">PO Number</th>
                <th scope="col" style="min-width: 150px;padding-right: 8px;">Vendor name</th>
                <th scope="col" style="min-width: 150px;padding-right: 8px;">Amount</th>
              </thead>
              <tbody>
                <tr *ngFor="let data of approvePaymentList">
                  <td style="padding-left: 25px;">{{data.lead_id}}</td>
                  <td>{{data.lead_name}}</td>
                  <td>{{data.boq_number}}</td>
                  <td>{{data.po_name}}</td>
                  <td>{{data.vendor_name}}</td>
                  <td>{{data.ammount}}</td>
                </tr>
              </tbody>
            </table>
            <!-- <div class="col-12 not-found" *ngIf="list_delay_lead.length == 0">
              <div class="boq-img text-center">
                <img src="../../../assets/img/desktop.png" />
              </div>
              <p class="nothing-to-show pb-4">Nothing to show...</p>
            </div> -->
          </div>
          <div class="col-12 ">
            <div style="font-size: 16px; margin-bottm:15px; margin-top: 15px;">Not Approved Payment</div>
            <table >
              <thead class="">
                <th scope="col" style="padding-left: 25px;min-width: 150px;padding-right: 8px;">
                  Lead ID</th>
                <th scope="col" style="min-width: 170px;padding-right: 8px;">Lead Name</th>
                <th scope="col" style="min-width: 175px;padding-right: 8px;">BOQ Number</th>
                <th scope="col" style="min-width: 170px;padding-right: 8px;">PO Number</th>
                <th scope="col" style="min-width: 150px;padding-right: 8px;">Vendor name</th>
                <th scope="col" style="min-width: 150px;padding-right: 8px;">Amount</th>
              </thead>
              <tbody>
                <tr *ngFor="let data of notApprovePaymentList">
                  <td style="padding-left: 25px;">{{data.lead_id}}</td>
                  <td>{{data.lead_name}}</td>
                  <td>{{data.boq_number}}</td>
                  <td>{{data.po_name}}</td>
                  <td>{{data.vendor_name}}</td>
                  <td>{{data.ammount}}</td>
                </tr>
              </tbody>
            </table>
            <!-- <div class="col-12 not-found" *ngIf="list_delay_lead.length == 0">
              <div class="boq-img text-center">
                <img src="../../../assets/img/desktop.png" />
              </div>
              <p class="nothing-to-show pb-4">Nothing to show...</p>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Message popup for approve vendor payment -->



// WEBPACK FOOTER //
// ./src/app/platform/finance/vendor-payment/vender-messge-dialog/vender-messge-dialog.component.html